module.exports = __webpack_public_path__ + "img/story027@2x.c6af7eef.webp";